import { Blogs, Currencies, Settings } from "types/BigCommerce";

import { BcStore } from "ts/types";
import { createSlice } from "@reduxjs/toolkit";
import { getGlobalStore } from "app/bigcommerce/helpers/BcConfigHelper";

export const bcStoreSlice = createSlice({
	name: "bcStore",
	initialState: {
		store: null as null | BcStore,
		currencies: [] as Currencies,
		settings: null as null | Settings,
		globalPreorderImage: null as null | Blogs,
		loyaltyProgramAvailable: false as boolean,
	},
	reducers: {
		setStore: (state, action) => {
			state.store = action.payload ? action.payload : getGlobalStore();
		},
		setCurrencies: (state, action: { payload: Currencies }) => {
			const currencies = action.payload;
			return { ...state, currencies };
		},
		setSettings: (state, action: { payload: Settings }) => {
			const settings = action.payload;
			return { ...state, settings };
		},
		setGlobalPreorderImage: (state, action: { payload: Blogs }) => {
			const globalPreorderImage = action.payload;
			return { ...state, globalPreorderImage };
		},
	},
});

export const { setStore, setCurrencies, setSettings, setGlobalPreorderImage } =
	bcStoreSlice.actions;

export default bcStoreSlice.reducer;

export const selectStore = (state: any): BcStore => state.bcStore.store;
